import React, { useCallback, useState } from "react"
import { graphql } from "gatsby"
import { Image } from "components/image/Image"
import { GallerySlider } from "./GallerySlider"
import { GalleryOverlay } from "./GalleryOverlay"
import { SingleGalleryImage } from "./gallery-types"

import "./gallery.module.scss"

interface GalleryProps {
  heading: string | null
  sub_heading: string | null
  image_gallery: SingleGalleryImage[]
}

export const Gallery = ({
  image_gallery,
  heading,
  sub_heading,
}: GalleryProps) => {
  const [isOverlay, setIsOverlay] = useState(false)
  const [firstSlideIndex, setFirstSlideIndex] = useState(0)

  const handleCloseOverlay = useCallback(() => {
    setIsOverlay(false)
  }, [])

  const openOverlay = (index: number) => {
    setFirstSlideIndex(index)
    setIsOverlay(true)
  }

  return (
    <section
      className={`gallery fr-container ${
        heading ? "u-content-block-padding" : ""
      }`}
    >
      {heading && <h2 className="gallery__title">{heading}</h2>}
      {sub_heading && <p>{sub_heading}</p>}
      <div
        className={`gallery__images ${
          sub_heading ? "gallery__images--with-sub-heading" : ""
        }`}
      >
        {image_gallery.map(({ image, id }, index) => {
          return (
            <div key={id} onClick={() => openOverlay(index)}>
              <Image
                image={image}
                alt={image?.alternativeText ?? ""}
                className="gallery__image"
              />
            </div>
          )
        })}
      </div>
      <GalleryOverlay isOverlay={isOverlay} onClose={handleCloseOverlay}>
        <GallerySlider
          images={image_gallery}
          firstSlideIndex={firstSlideIndex}
        />
      </GalleryOverlay>
    </section>
  )
}

export const strapiQuery = graphql`
  fragment StrapiGalleryFragment on STRAPI__COMPONENT_CONTENT_BLOCK_IMAGE_GALLERY {
    id
    strapi_component
    heading
    sub_heading
    image_gallery {
      id
      caption
      image {
        ...StrapiImageFragment
      }
    }
  }
`
